<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div class="card">
	<h2 class="card-title mb-0 pb-0">
		Question List
		<a class="btn btn-sm btn-outline-success float-end" [routerLink]="['/app/create-question']">
			<fa-icon [icon]="['fas', 'plus']"></fa-icon>
			Create Question
		</a>
	</h2>
	<div class="card-body pt-1">
		<table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered table-hover">
			<thead>
				<tr>
					<th style="width: 85%;">Question</th>
					<th style="width: 15%;">Action</th>
				</tr>
			</thead>
			<tbody *ngIf="dataList?.length != 0">
				<tr *ngFor="let v of dataList;let i = index;">
					<td>{{ v.question_name }}</td>
					<td>
						<a class="btn btn-xs btn-outline-primary" matTooltip="Edit"
							[routerLink]="['/app/edit-question',v.encryptid]">
							<fa-icon [icon]="['fas', 'edit']"></fa-icon>
						</a>
						<button class="btn btn-xs btn-outline-danger ms-1" matTooltip="Delete"
							(click)="deleteModal(v.encryptid)">
							<fa-icon *ngIf="deleteLoader != v.encryptid" [icon]="['fas', 'times']"></fa-icon>
							<fa-icon *ngIf="deleteLoader == v.encryptid" [icon]="['fas', 'spinner']"
								[animation]="'spin'"></fa-icon>
						</button>
					</td>
				</tr>
			</tbody>
			<tbody *ngIf="dataList?.length == 0">
				<tr>
					<td colspan="2" class="text-center">No data found!</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>